// Vendors
import { ModalComponent } from '@openbank/ziniaweb-ui-components';
import type { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Components
import { BackgroundContentComponent } from './components/content/background-content.component';
import { BackgroundFooterComponent } from './components/footer/background-footer.component';
import { BackgroundTitleComponent } from './components/title/background-title.component';
import { FeatureFlagComponent } from 'components/feature-flag/feature-flag.component';
// Constants
import {
  BACKGROUND_MODAL_COMPONENT_PROPS,
  BACKGROUND_MODAL_FEATURE_FLAG_PROPS,
} from './constants/background.constants';
// Hooks
import { useBackgroundHook } from './hooks/background.hook';

const BackgroundProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  const { showBackgroundModal, setShowBackgroundModal } = useBackgroundHook();

  return (
    <>
      <FeatureFlagComponent {...BACKGROUND_MODAL_FEATURE_FLAG_PROPS}>
        {showBackgroundModal && (
          <ModalComponent
            {...BACKGROUND_MODAL_COMPONENT_PROPS}
            content={<BackgroundContentComponent />}
            footer={<BackgroundFooterComponent {...{ setShowBackgroundModal }} />}
            title={{ content: <BackgroundTitleComponent /> }}
          />
        )}
      </FeatureFlagComponent>
      {children}
    </>
  );
};

export { BackgroundProvider };
